// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_10DB_MVB8QiIqQRQ-Jq1Px","icon":"_22hVu9aNvmNQqsSaC_3aif","active":"_1JRC7xc4AGn1PSxALcesng"};